/** @format */
import React, { useState, useEffect, lazy, Suspense } from "react";
import { useSelector, connect } from "react-redux";
// import { useKeycloak } from "@react-keycloak/ssr";
import { useCookies } from "react-cookie";
import Link from "next/link";
import { useRouter } from "next/router";
import { enquireScreen } from "enquire-js";
import dynamic from "next/dynamic";
import { v4 as uuidv4 } from "uuid";
const DrawerMobile = dynamic(() => import("./DrawerMobile"), {ssr: false});
const NavBar = dynamic(() => import("./NavBar"), {ssr: false});
const HeaderSearchWeb = dynamic(() => import("./HeaderSearchWeb"), {ssr: false});
const HeaderSearchMob = dynamic(() => import("./HeaderSearchMob"), {ssr: false});
import { usePathname } from "next/navigation";
import { ReactSVG } from "react-svg"; // using this package bcs qalara logo svg was invisible in mobile
import {
  Layout,
  Button,
  Menu,
  Modal,
  Row,
  Col,
  Popover,
  Drawer,
  Avatar,
  Dropdown,
  Select,
  Form,
  Input,
  AutoComplete,
  message,
} from "antd";
import Icon, {
  CheckCircleOutlined,
  ShoppingCartOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import Marquee from "react-fast-marquee";
// import Link from "next/link"; // if using Next.js
import { loginToApp, registerToApp, logoutFromApp } from "../AuthWithKeycloak";
import closeButton from "../../public/filestore/closeButton";
import backIcon from "../../public/filestore/backIcon";
import homeIconHeader from "../../public/filestore/homeIconHeader";
import MyAccountIcon from  "../../public/filestore/myAccount";
import MyAccountIconW from  "../../public/filestore/myAccountIconW";
//import headerCollectionIcon from "../../public/filestore/headerCollectionIcon";
import HeaderCollectionIcon  from "../../public/filestore/headerCollectionIcon";
import accountIcon from "../../public/filestore/accountIcon";
// const CurrencyConverter = dynamic(() => import("../common/CurrencyConverter"), {ssr: false});
import CurrencyConverter from "../common/CurrencyConverter";
import { logger } from "@goldenbird1/ui-logger-library";
import {
  getUserProfile,
  getCurrencyConversion,
  getCurrentFormat,
  completeUserRegistration,
  getTokenFromRefreshToken,
  getAccessTokenSocial,
  saveUserIPDetails,
  keycloakLogout
} from "./../../store/actions";
import {
  pushMeta,
  menuNavigation,
  topNavigation,
  logoutEvent,
  formSubmit,
  formView,
  apiError,
  signupEvent,
  useDetectWebView,
  unique_page_views,
  search_exit,
  rfq_click,
} from "../../utils/GTMDataLayer";
const OtpInput = dynamic(() => import("react-otp-input"), {ssr: false});
// import OtpInput from "react-otp-input";
const CompleteProfileForm = dynamic(() => import("../UserRegistration/CompleteProfileForm"), {ssr: false});
// const HomeModal = lazy(() => import("../HomeModal/HomeModal"));
import HomeModal from "../HomeModal/HomeModal";
const UserMenu = dynamic(() => import("./UserMenu"), {ssr: false});
import NewCartIcon from "../../public/filestore/newCartIcon";
import MobCartIcon from "../../public/filestore/mobCartIcon";
import RfqNewIcon from "../../public/filestore/rfqNewIcon";
import MobRfqIcon from "../../public/filestore/mobRfqIcon";
import Spinner from "../Spinner/Spinner";
// import { signupComplete, pageView } from "../../utils/moEngageEvents";
import { sendDataToMobileApplication } from "../../utils/sendDataToMobile";
import { accessToken } from "../../utils/accessToken";
import moment from "moment";
import cookie from "js-cookie";
import { trackUserSession } from "../../utils/trackUserSession";
import { getCartProductQuantity } from "../../store/actions/cartProductsQuantity";
// import AnnouncementTicker from "./AnnouncementTicker";

const { Header } = Layout;
const { SubMenu } = Menu;
const { Option } = AutoComplete;

function UserHeader(props) {
  let { priceDetails = {}, nav, isShowRibbon } = props;
  // const { keycloak } = useKeycloak();
  const [isLoading, setIsLoading] = useState(true);
  const [local,setLocal] = useState(true)
  // let isAuthenticated = local; /* read directly from keycloak for now */
  // let isAuthenticated = keycloak?.authenticated;
  const [stateAuth, setStateAuth] = useState(props.userProfile?.userProfile);
  let mediaMatch =
    typeof window == "undefined" ? "" : window.matchMedia("(min-width: 768px)");
  const router = useRouter();
  let { convertToCurrency = "" } = priceDetails || {};
  const [shopVisible, setShopVisible] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const [successQueryVisible, setSuccessQueryVisible] = useState(false);
  const [isPendingRFQ, setIsPendingRFQ] = useState(false);
  // const [previousPageName, setPreviousPageName] = useState(" ");
  // const [currentPageName, setCurrentPageName] = useState(" ");
  const [isDeviceDetected, setIsDeviceDetected] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    enquireScreen((status) => {
        setIsMobile(status);
      }
    );
    setIsDeviceDetected(true);
  }, []);
 
  // useEffect(()=>{
  //   if(typeof(pathname)==='string'){
  //   if(pathname==='/'){
  //     setPreviousPageName(currentPageName);
  //     setCurrentPageName("home page");
  //   }else{
  //     const indexValue = pathname.slice(1).indexOf('/');
  //     const currentPage= pathname.slice(1,indexValue+1);
  //     if(currentPage==='products'){
  //       setPreviousPageName(currentPageName);
  //       setCurrentPageName('plp page');
  //     }else if(currentPage==='product'){
  //       setPreviousPageName(currentPageName);
  //       setCurrentPageName('pdp page');
  //     }else if(router?.query?.section){
  //       setPreviousPageName(currentPageName);
  //       setCurrentPageName(router?.query.section);
  //     } else {
  //       setPreviousPageName(currentPageName);
  //       setCurrentPageName(currentPage);
  //     }
  //   }
  // }
  // },[pathname])
  // useEffect(()=>{
  //   if(previousPageName!==" " || currentPageName!==" "){
  //     // pageView(currentPageName,previousPageName);
  //     trackUserSession();
  //     unique_page_views(currentPageName);
  //   }
  // },[previousPageName,currentPageName])

  // const appToken = useSelector(
  //   (state) => state.appToken.token && state.appToken.token.access_token
  // );

  const [shopColor, setShopColor] = useState(false);
  // const token = keycloak.token || appToken;
  const [inviteAccess, setInviteAccess] = useState(false);
  const [selectedType, setSelectedType] = useState("product");
  const [close, setClose] = useState(false);
  const [accVisible, setAccVisible] = useState(false);

  let { userProfile } = props.userProfile;

  const [imageUrl, setImageUrl] = useState(
    props.userProfile.userProfile &&
      props.userProfile.userProfile.profileImage &&
      props.userProfile.userProfile.profileImage.media &&
      props.userProfile.userProfile.profileImage.media.mediaUrl &&
      process.env.NEXT_PUBLIC_REACT_APP_ASSETS_FILE_URL +
        props.userProfile.userProfile.profileImage.media.mediaUrl
  );

  const [notificationMsg, setNotificationMsg] = useState("");
  const [inProgressMsg, setInProgressMsg] = useState("");
  const [newUser, setNewUser] = useState(false);
  const [previousUrl, setPreviousUrl] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [uProfile, setUProfile] = useState("BUYER");
  const [verificationModal, setVerificationModal] = useState(false);
  const [otpVerificationModal, setOtpVerificationModal] = useState(false);
  const [otpInput, setOtpInput] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [otpLengthError, setOtpLengthError] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([""]);
  const [dataSource, setDataSource] = useState([]);
  const [enteredText, setEnteredText] = useState("");

  const [finalMenuList, setFinalMenuList] = useState([]);
  const [catNavVisible, setCatNavVisible] = useState(false);
  const [catNavColor, setCatNavColor] = useState(false);
  const [dc, setDc] = useState(false);
  const [odc, setoDc] = useState(false);
  const [modalVisible, setModalVisible] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isShowUserMenu, setIsShowUserMenu] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [stateProfileType, setStateProfileType] = useState(null);
  // const[UTMparams,setUTMparams]=useState({});
  const [userStatus, setUserStatus] = useState(false);

  let token = '';
  let appToken = '';

  token = accessToken();

  useEffect(() => {
    // ?utm_source=google&utm_medium=display_gmail&utm_campaign=remarketing&utm_term=test
    // extract utm source param from current url //
    const currentUrl = typeof window == "undefined" ? "" : window.location.href;
    var params = {};
    /* check for utm_source || gclid || fbid */
    
    if (new URL(currentUrl).searchParams.get("utm_source")) {
      params = {
        utm_source: new URL(currentUrl).searchParams
          .get("utm_source")
          .replace(/['"]/g, ""),
        utm_medium: new URL(currentUrl).searchParams.get("utm_medium")
          ? new URL(currentUrl).searchParams
              .get("utm_medium")
              .replace(/['"]/g, "")
          : "",
        utm_campaign: new URL(currentUrl).searchParams.get("utm_campaign")
          ? new URL(currentUrl).searchParams
              .get("utm_campaign")
              .replace(/['"]/g, "")
          : "",
        utmTerm: new URL(currentUrl).searchParams.get("utm_term")
          ? new URL(currentUrl).searchParams
              .get("utm_term")
              .replace(/['"]/g, "")
          : "",
          utm_device: new URL(currentUrl).searchParams.get("utm_device")
           ? new URL(currentUrl).searchParams.get("utm_device").replace(/['"]/g, "")
           : ""
      };
      // setUTMparams(params)
      /* ----- */
      params.utm_source &&
        setCookie("utm_source", params, {
          path: "/",
          maxAge: 60 * 60 * 24 * 7,
        });
      // ======= //
    }
  }, []);

  useEffect(() => {
    console.log('m in userHeader')
    token = accessToken();
    // if(localStorage.getItem('kcAccessToken')){
    //   token = localStorage.getItem('kcAccessToken');
    //   appToken = localStorage.getItem('kcAccessToken');
    // } else {
    //   if(router.asPath === '/signup'){
    //     router.push('/signup');
    //   } else {
    //     router.push(router.asPath);
    //   }
    // }
    if(!token){
      console.log('called from userheader 11');
      router.push('/signin');
    } else {
      appToken = token;
      if(router.asPath === '/signup'){
        router.push('/signup');
      } else {
        router.push(router.asPath);
      }
    }
    if(localStorage && localStorage.getItem('userProfile')){
      let profile = JSON.parse(localStorage.getItem('userProfile'));
      if(!profile.profileComplete){
        setVerificationModal(true);
      } else {
        setVerificationModal(false);
      }
    };
    if(!props.userProfile.userProfile && localStorage.getItem('kcAccessToken')){
      // check if access token is valid
      let saved = localStorage.getItem("kcTokenSaved");
      if(localStorage.getItem('kcRefreshToken') && new Date().getTime() - saved < 9000000)
      {
        console.log('m in header 1')
        let tkn = localStorage.getItem('kcAccessToken');
        tkn && props.getUserProfile(tkn, (result) => {
          let { error = false } = result;
          if(error){
            retryProfile();
          }
        });
      }
    }

    // keep track of user path to route back to it inCase of sign-up completion
    if(router.pathname){
      console.log('router', router.asPath)
      let routesToIgnore = ['/signin/', '/signup/', '/forgotpassword/'];
      if(!router.asPath.includes('session_state')){
      if(!routesToIgnore.includes(router.asPath) && router.asPath.split('/')[1] !== 'resetpassword'){
        localStorage.setItem('pathname', router.asPath)
      }
    }
    }

    console.log('router'  ,router);
    if(router.query && router.query.code){
      //get access token from code - social signup
      let code = router.query.code;
      props.getAccessTokenSocial(code, (result) => {
        let {error = ''} = result;
        if(error){
          message.error('Something went wrong. Please try again.', 5);
          apiError("user login", error||"error in login api","post","user profile");
        } else {
          console.log(result);
          // capture user IP, country social-signup
          if(sessionStorage.getItem('isSocialSignup')){
            if(sessionStorage.getItem('userIp')){
              signupEvent();
              let buyerId = props.userProfile && props.userProfile?.userProfile?.profileId ? props.userProfile?.userProfile?.profileId : null;
              let userIp = sessionStorage.getItem('userIp') ? JSON.parse(sessionStorage.getItem('userIp')).ip : null;
              let userCountry = sessionStorage.getItem('userIp') ? JSON.parse(sessionStorage.getItem('userIp')).country_name : null;

              /* get utm values if present in cookies */
              let utmdata = {};
              if (cookies.utm_source) {
                let cookieVal = cookies.utm_source;

                utmdata.utm = cookieVal.utm_source.replace(/['"]/g, "");
                utmdata.utmCampaign = cookieVal?.utm_campaign.replace(
                  /['"]/g,
                  ""
                );
                utmdata.utmMedium = cookieVal?.utm_medium.replace(/['"]/g, "");
                utmdata.utmTerm = cookieVal?.utmTerm.replace(/['"]/g, "");
                utmdata.utmDevice = cookieVal?.utm_device.replace(/['"]/g, "");
              }
              /*----*/
              // console.log("UTM===============",utmdata)

              let ipData = {
                "ipAddress": userIp,
                "country": userCountry,
                utm:utmdata?.utm || null,
                utmTerm:utmdata?.utmTerm || null,
                utmCampaign:utmdata?.utmCampaign || null,
                utmMedium:utmdata?.utmMedium || null, 
                utmDevice: utmdata?.utmDevice || null
              }
              if(result.access_token){
                props.saveUserIPDetails(ipData, result.access_token, buyerId);
              }
            }
          }
          localStorage.setItem('shortTimeUser', new Date().getTime());
          localStorage.setItem("kcTokenSaved", new Date().getTime());
          localStorage.setItem('kcAccessToken', result.access_token);
          localStorage.setItem('kcRefreshToken', result.refresh_token);
          localStorage.setItem('rValidity', result.refresh_expires_in);
          localStorage.setItem('aValidity', result.expires_in);
          props.getUserProfile(result.access_token, (resp) => {
            let { error = false } = resp;
            if(error){
              retryProfile();
            }
            if(!resp.profileComplete){
              setVerificationModal(true);
            } else {
              setVerificationModal(false);
            }
          });
          props.getCartProductQuantity(result.access_token);
          if(localStorage.getItem('pathname')){
            router.push(localStorage.getItem('pathname'));
          } else {
            router.push('/explore/shopnow/');
          }
        }
      });
    }
  }, []);

  // useEffect(() => {
  //   // capture user IP, country social-signup
  //   if(sessionStorage.getItem('isSocialSignup')){
  //     if(sessionStorage.getItem('userIp')){
  //       let buyerId = props.userProfile && props.userProfile?.userProfile?.profileId ? props.userProfile?.userProfile?.profileId : null;
  //       let userIp = sessionStorage.getItem('userIp') ? JSON.parse(sessionStorage.getItem('userIp')).ip : null;
  //       let userCountry = sessionStorage.getItem('userIp') ? JSON.parse(sessionStorage.getItem('userIp')).country_name : null;
  //       let ipData = {
  //         "ipAddress": userIp,
  //         "country": userCountry
  //       }
  //       props.saveUserIPDetails(ipData, token, buyerId);
  //     }
  //   }
  // }, []);

  const poorProfileStatus = ["ON_HOLD", "REJECTED"];

  let retryCountOtp = 0;
  let retryCountRFQ = 0;

  const getAccessToken = (refreshT) => {
    props.getTokenFromRefreshToken(refreshT, (result) => {
      let {error = '', status = ''} = result;
      if(error){
        message.error('Something went wrong. Please try signing-in again.', 5);
      } else if(status && status === 500){
        router.push('/signin');
      } else {
        if(localStorage.getItem('kcRefreshToken')){
          localStorage.removeItem('kcAccessToken');
          localStorage.removeItem('kcRefreshToken');
          // removeCookie('kcAccessToken', {path: '/'});
          // removeCookie('kcRefreshToken', {path: '/'});
          localStorage.removeItem('rValidity');
          localStorage.removeItem('aValidity');
          localStorage.removeItem('kcTokenSaved');
        }
        localStorage.setItem("kcTokenSaved", new Date().getTime());
        localStorage.setItem('kcAccessToken', result.access_token);
        localStorage.setItem('kcRefreshToken', result.refresh_token);
        localStorage.setItem('rValidity', result.refresh_expires_in);
        localStorage.setItem('aValidity', result.expires_in);
        if(!props.userProfile.userProfile){
          console.log('m in header')
          props.getUserProfile(result.access_token, (res) => {
            let { error = false } = res;
            if(error){
              retryProfile();
            } else {
              window.location.reload(); //reload after getting access token and userprofile every 2.5 hours
            }
          });
        }
      }
    });
  }

  useEffect(()=>{
    localStorage.setItem("isAnalyticsCookieAllowed",cookies.cookieHubAnalytics);
    localStorage.setItem("isMarketingCookieAllowed",cookies.cookieHubMarketing);
  },[cookies])

  useEffect(() => {
    enquireScreen((status) => {
       if(status){
        if(priceDetails && priceDetails.rates.length === 0){
          console.log('CURRENCY_SELECTED', localStorage.getItem('CURRENCY_SELECTED'), props.userProfile, priceDetails )
          let baseCurrency = localStorage.getItem('CURRENCY_SELECTED') ? localStorage.getItem('CURRENCY_SELECTED') : 'USD';
          let buyerId = props.userProfile && props.userProfile?.userProfile?.profileId ? props.userProfile?.userProfile?.profileId : null;
          // props.getCurrencyConversion(baseCurrency, buyerId);
          props.getCurrencyConversion(baseCurrency, buyerId, (result) => {
            let { error = false } = result;
            if(error) {
              message.error('Something went wrong. Please try again in sometime.', 5);
            }
          });
          let currencySelected = localStorage.getItem("CURRENCY_SELECTED") || "USD";
          props.getCurrentFormat(currencySelected);
        }
       }
      }
    );
    // check if user has created account or not
    // if(localStorage.getItem('kcRefreshToken')){
    if(localStorage.getItem('kcRefreshToken')){
      // fetch access token every 5 minutes
      // let refresh_token = localStorage.getItem('kcRefreshToken');
      let refresh_token = localStorage.getItem('kcRefreshToken');
      // get access token every 2.5 hours
      if(localStorage.getItem("kcTokenSaved") && localStorage.getItem('longTimeUser')){ // if user has selected remember me
        // check if refresh token is still valid
        let rTime = localStorage.getItem('rValidity');
        let saved = localStorage.getItem("kcTokenSaved");
        if(new Date().getTime() - saved > rTime * 1000) { // check the validity of refresh token
          console.log('m called from userheader 12');
          router.push('/signin'); // if token is saved for more than 90 days i.e. refresh token validity, take user to sign-in page
        } else {
          if(saved &&
            localStorage.getItem('kcRefreshToken') &&
            new Date().getTime() - saved >= 9000000 // get access token every 2.5 hours
          ){
            getAccessToken(refresh_token);
          } else {
            let currentUrl = router.asPath;
            router.push(currentUrl);
          }
          setTimeout(() => {
            let saved = localStorage.getItem("kcTokenSaved");
            if(saved &&
              localStorage.getItem('kcRefreshToken') &&
              new Date().getTime() - saved >= 9000000 // get access token every 2.5 hours
            ){
              getAccessToken(refresh_token);
            } else {
              let currentUrl = router.asPath;
              router.push(currentUrl);
            }
          }, 9000000); 
        }
      } else if(localStorage.getItem("kcTokenSaved") && localStorage.getItem('shortTimeUser')){
        console.log('m here for shortTimeUser')
        let saved = localStorage.getItem("kcTokenSaved");
        if (
          saved &&
          localStorage.getItem('kcRefreshToken') &&
          new Date().getTime() - saved >= 9000000  // get access token every 2.5 hours
        ) {
          console.log('m called from userheader 13');
          router.push('/signin');
          // getAccessToken(refresh_token);
          // setInterval(() => {
          //   let saved = localStorage.getItem("kcTokenSaved");
          //   if(saved &&
          //     localStorage.getItem('kcRefreshToken') &&
          //     new Date().getTime() - saved >= 9000000  // get access token every 2.5 hours
          //   ){
          //     getAccessToken(refresh_token);
          //   } else {
          //     router.push('/signin');
          //   }
          // }, 9000000); 
        } else {
          console.log('m in here 13');
          let currentUrl = router.asPath;
          router.push(currentUrl);
        }
      } 
    } else {
      // router.push('/signin');
    }
  }, []);

  useEffect(() => {
    // if(keycloak?.authenticated){
    //   setIsAuthenticated(true);
    // }
    if(localStorage.getItem('kcTokenSaved')){
      setIsAuthenticated(true);
      setIsLoading(false);
      setUserStatus(true);
    } else {
      setIsAuthenticated(false);
      setIsLoading(false);
      setUserStatus(true);
    }
  }, [props.userProfile]);

  useEffect(()=>{
    // setLocal(localStorage.getItem('loggedInUser'))
  }, [props])

  useEffect(() => {
    try{
     let iswebview = useDetectWebView();
     if(iswebview){
      localStorage.setItem("webview",true);
     }else{
      localStorage.setItem("webview",false);
     }
    } catch (error) {
      console.warn(error);
    }
  })

  useEffect(() => {
    // extract utm source param from current url //
    const currentUrl = typeof window == "undefined" ? "" : window.location.href;
    var params = {};
    /* check for utm_source || gclid || fbid */
    
    if (new URL(currentUrl).searchParams.get("utm_source")) {
      params = {
        utm_source: new URL(currentUrl).searchParams
          .get("utm_source")
          .replace(/['"]/g, ""),
        utm_medium: new URL(currentUrl).searchParams.get("utm_medium")
          ? new URL(currentUrl).searchParams
              .get("utm_medium")
              .replace(/['"]/g, "")
          : "",
        utm_campaign: new URL(currentUrl).searchParams.get("utm_campaign")
          ? new URL(currentUrl).searchParams
              .get("utm_campaign")
              .replace(/['"]/g, "")
          : "",
        utmContent: new URL(currentUrl).searchParams.get("utm_content")
          ? new URL(currentUrl).searchParams
              .get("utm_content")
              .replace(/['"]/g, "")
          : "",
        utmTerm: new URL(currentUrl).searchParams.get("utm_term")
          ? new URL(currentUrl).searchParams
              .get("utm_term")
              .replace(/['"]/g, "")
          : "",
        adGroupId: new URL(currentUrl).searchParams.get("adgroupid")
          ? new URL(currentUrl).searchParams
              .get("adgroupid")
              .replace(/['"]/g, "")
          : "",
        keyword: new URL(currentUrl).searchParams.get("keyword")
          ? new URL(currentUrl).searchParams
              .get("keyword")
              .replace(/['"]/g, "")
          : "",
        device: new URL(currentUrl).searchParams.get("device")
          ? new URL(currentUrl).searchParams
              .get("device")
              .replace(/['"]/g, "")
          : "",
        utm_device: new URL(currentUrl).searchParams.get("utm_device")
           ? new URL(currentUrl).searchParams.get("utm_device").replace(/['"]/g, "")
           : ""
      };
    } else if (new URL(currentUrl).searchParams.get("gclid")) {
      params = {
        utm_source: "google",
        utm_medium: "",
        utm_campaign: new URL(currentUrl).searchParams
          .get("gclid")
          .replace(/['"]/g, ""),
          utmTerm: new URL(currentUrl).searchParams.get("utm_term")
          ? new URL(currentUrl).searchParams
              .get("utm_term")
              .replace(/['"]/g, "")
          : "",
          adGroupId: new URL(currentUrl).searchParams.get("adgroupid")
          ? new URL(currentUrl).searchParams
              .get("adgroupid")
              .replace(/['"]/g, "")
          : "",
          keyword: new URL(currentUrl).searchParams.get("keyword")
          ? new URL(currentUrl).searchParams
              .get("keyword")
              .replace(/['"]/g, "")
          : "",
          utm_device: new URL(currentUrl).searchParams.get("utm_device")
           ? new URL(currentUrl).searchParams.get("utm_device").replace(/['"]/g, "")
           : ""
      };
    } else if (new URL(currentUrl).searchParams.get("fbid")) {
      params = {
        utm_source: "facebook",
        utm_medium: "",
        utm_campaign: new URL(currentUrl).searchParams
          .get("fbid")
          .replace(/['"]/g, ""),
          utmTerm: new URL(currentUrl).searchParams.get("utm_term")
          ? new URL(currentUrl).searchParams
              .get("utm_term")
              .replace(/['"]/g, "")
          : "",
          adGroupId: new URL(currentUrl).searchParams.get("adgroupid")
          ? new URL(currentUrl).searchParams
              .get("adgroupid")
              .replace(/['"]/g, "")
          : "",
          keyword: new URL(currentUrl).searchParams.get("keyword")
          ? new URL(currentUrl).searchParams
              .get("keyword")
              .replace(/['"]/g, "")
          : "",
          utm_device: new URL(currentUrl).searchParams.get("utm_device")
           ? new URL(currentUrl).searchParams.get("utm_device").replace(/['"]/g, "")
           : ""
      };
    }

    // if(params.utm_campaign !== undefined  ){
    //   if(Object.keys(params).length !==0){
    //   }
    //     setUTMparams(params);
    //     localStorage.setItem("utm_source", params.utm_source);
    //     localStorage.setItem("utm_medium", params.utm_medium);
    //     localStorage.setItem("utm_campaign", params.utm_campaign);
    //     localStorage.setItem("utmTerm", params.utmTerm);
        
    // }


    /* ----- */
    params.utm_source &&
      setCookie("utm_source", params, {
        path: "/",
        maxAge: 60 * 60 * 24 * 7,
      });
    // ======= //

    try {
      // let { profileType, profileId, country } =
      //   props?.userProfile?.userProfile;
      let verificationStatus = props.userProfile && props.userProfile?.userProfile ? props.userProfile?.userProfile.verificationStatus : null;
      let profileType = props.userProfile && props.userProfile?.userProfile ? props.userProfile?.userProfile.profileType : null;
      let profileId = props.userProfile && props.userProfile?.userProfile ? props.userProfile?.userProfile.profileId : null;
      let country = props.userProfile && props.userProfile?.userProfile ? props.userProfile?.userProfile.country : null;

      profileId = profileId ? profileId.split("::")[1] : "";
      pushMeta({
        event: "meta_push",
        verificationStatus,
        profileType,
        profileId,
        country,
        userType: "logged in",
      });
    } catch (err) {
      console.warn("Compount mount of User Header error: " + err);
    }

    // console.log('check if back is there', document && document.referrer);
  }, [props.userProfile.userProfile]);

  useEffect(() => {
    /* -- remove storage search info if routed to other page than search -- */
    let searchParam = router.asPath.split('/');
    if(!searchParam[1] === 'search' || router.asPath === '/'){
      sessionStorage.removeItem('argoidSearchId');
      sessionStorage.removeItem('sQP');
    }
    /* ---- */
    //remove sessionStorage for sentProducts to GA
    sessionStorage.removeItem('sentProducts');
  }, []);

  const handleLogin = () => {
    // loginToApp(keycloak, { currentPath: router.asPath.split("?")[0] });
    // loginToApp(keycloak, { currentPath: router.asPath });
    if(localStorage.getItem('kcTokenSaved')){
      // setLoggedIn(true);
      setIsAuthenticated(true);
    } else {
      router.push('/signin');
    }
  };

  const handleSignUp = () => {
    // router.push("/signup");
    // registerToApp(keycloak, { currentPath: router.asPath });
    router.push('/signup');
  };

  /* remove focus from search input box in case of change of route MV-7540 */
  useEffect(() => {
      const hideMobileKeyboardOnReturn = (element) => {
        element.blur();
      };

      document.querySelectorAll('[type=search]').forEach((element) => {
          hideMobileKeyboardOnReturn(element);
      }); 
  }, [router]);
  /* --------- */

  useEffect(() => {
    token && props.getCartProductQuantity(token);
  }, [props.cartProductsQuantity]);

  const sendOtp = () => {
    // startBrowserBack();
    formView("validate otp", "");
    setOtpError(false);
    setOtpVerificationModal(true);
    setOtpInput("");
    setOtpLengthError(false);
    setVerificationModal(false);
    let buyerId = props.userProfile && props.userProfile.userProfile.profileId ? props.userProfile.userProfile.profileId : null;
    let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL + "/otp";
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.text();
        } else {
          apiError(
            "sendOtp",
            res.statusText || "Error while sending otp. Please try again",
            "POST",
            "UserHeader.js"
          );
          throw res;
        }
      })
      .catch((err) => {
        apiError("sendOtp", err, "POST", "UserHeader.js");
        logger("error", "Error from sendOtp method UserHeader: " + url + ": buyerId =>  "+buyerId+ ': error => ' +err?.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        console.log("sendOtp POST UserHeader.js", err);
        if(err.status === 401){
          router.push('/signin');
        } else {
          if (retryCountOtp < 3) {
            sendOtp();
          } else {
            message.error(err.message || err, 5);
          }
          retryCountOtp++;
        }
      });
  };

  const hideOtpModal = () => {
    setOtpVerificationModal(false);
    setVerificationModal(false);
  };
  const handleOtpChange = (otp) => {
    setOtpInput(otp);
  };

  let retryUserProfile = 0;
  const retryProfile = () => {
    if(retryUserProfile < 3){
      let token = localStorage.getItem('kcAccessToken');
      token && props.getUserProfile(token, (result) => {
        let { error = false } = result;
        if(error){
          retryProfile();
        }
      });
    }
    retryUserProfile++;
  }

  const handleUserMenu = (flag) => {
    if(userProfile && !userProfile.orgName){
      token && props.getUserProfile(token, (result) => {
        let { error = false } = result;
        if(error){
          retryProfile();
        }
      });
    }
    setAccVisible(flag);
  };

  const validateOtp = () => {
    const buyerId = userProfile?.profileId?.replace(
      "BUYER::",
      ""
    );
    if (otpInput.length !== 6) {
      setOtpLengthError(true);
    } else {
      setBtnLoading(true);
      setOtpLengthError(false);
      let buyerId = props.userProfile && props.userProfile?.profileId ? props.userProfile.profileId : null;
      let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/profile/v1/otp/validate";
      fetch(
        url,
        {
          method: "POST",
          body: otpInput,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            'trace-id' : uuidv4()
          },
        }
      )
        .then((res) => {
          if (res.ok) {
            formSubmit("validate otp", "");
            return res.text();
          } else {
            apiError(
              "validateOtp",
              res.statusText || "Oops something went wrong. Please try again!",
              "POST",
              "UserHeader.js"
            );
            throw res;
          }
        })
        .then((res) => {
          setBtnLoading(false);
          setOtpVerificationModal(true);
          setVerificationModal(false);
          setOtpError(false);
          setOtpValidated(true);
          token && props.getUserProfile(token, (result) => {
            let { error = false } = result;
            if(error){
              retryProfile();
            }
          });
        })
        .catch((err) => {
          apiError("validateOtp", err, "POST", "UserHeader.js");
          logger("error", "Error from validateOtp method UserHeader: " + url + ": buyerId =>  "+buyerId+ ': error => ' +err?.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
          if(err.status === 401){
            router.push('/signin');
          }
          console.log("validateOtp POST UserHeader.js", err);
          setOtpError(true);
          setOtpValidated(false);
          setBtnLoading(false);
          // message.error(err.message || err, 5);
        });
    }
  };

  const closeConfimationModal = () => {
    setConfirmationModal(false);
  };

  const stopBrowserBack = (callback = "") => {
    if (typeof window != "undefined") {
      window.location.hash = "no-back";

      // Again because Google Chrome doesn't insert
      // the first hash into the history
      window.location.hash = "no-back";

      window.onhashchange = function () {
        window.location.hash = "no-back";
      };
    }
  };

  const startBrowserBack = () => {
    window.onpopstate = undefined;
    window.history.back();
  };

  useEffect(() => {
    let notification = localStorage.getItem("show_notification");
    let {
      verificationStatus = "",
      profileType = "",
      verifiedEmail = false,
      profileComplete = true,
    } = props.userProfile.userProfile || {};
    if (props && props.userProfile && props.userProfile.userProfile) {
      if (profileComplete === null || profileComplete === false) {
        stopBrowserBack();
        setVerificationModal(true);
      }
    }
    if (
      props &&
      props.userProfile &&
      props.userProfile.userProfile &&
      notification === "yes" &&
      profileComplete
    ) {
      if (profileType === "BUYER") {
        if (
          (verifiedEmail === false || verifiedEmail === null) &&
          verificationStatus !== "VERIFIED"
        ) {
          setNotificationMsg("ACCOUNT_EMAIL_NOT_VERIFIED");
          // setOtpVerificationModal(true);
          localStorage.setItem("show_notification", "no");
        } else if (
          (verifiedEmail === false || verifiedEmail === null) &&
          verificationStatus === "VERIFIED"
        ) {
          setNotificationMsg("EMAIL_NOT_VERIFIED");
          // setOtpVerificationModal(true);
          localStorage.setItem("show_notification", "no");
        } else if (
          verifiedEmail === true &&
          verificationStatus !== "VERIFIED"
        ) {
          setNotificationMsg("ACCOUNT_NOT_VERIFIED");
          // setOtpVerificationModal(true);
          localStorage.setItem("show_notification", "no");
        }
      } else {
        if (verifiedEmail === false || verifiedEmail === null) {
          setNotificationMsg("EMAIL_NOT_VERIFIED");
          // setOtpVerificationModal(true);
          localStorage.setItem("show_notification", "no");
        }
      }
    }
    setStateAuth(props.userProfile.userProfile);
  }, [props.userProfile.userProfile]);

  useEffect(() => {
    setImageUrl(
      props.userProfile.userProfile &&
        props.userProfile.userProfile.profileImage &&
        props.userProfile.userProfile.profileImage.media &&
        props.userProfile.userProfile.profileImage.media.mediaUrl &&
        process.env.NEXT_PUBLIC_REACT_APP_ASSETS_FILE_URL +
          props.userProfile.userProfile.profileImage.media.mediaUrl
    );
  }, [props.userProfile.userProfile]);

  // useEffect(() => {
  //   let userLastActive = sessionStorage.getItem("userLastActive");
  //   if (
  //     props.userProfile.userProfile &&
  //     props.userProfile.userProfile.profileId
  //   ) {
  //     if (userLastActive !== props.userProfile.userProfile.profileId) {
  //       let profileId = props.userProfile.userProfile.profileId || "";
  //       profileId = profileId.replace("BUYER::", "");
  //       profileId = profileId.replace("SELLER::", "");
  //       let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL +
  //           "/profiles/" +
  //           profileId +
  //           "/events/active";
  //       fetch(
  //         url,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: "Bearer " + token,
  //           },
  //         }
  //       )
  //         .then((res) => {
  //           if (res.ok) {
  //             return res.json();
  //           } else {
  //             throw res.statusText || "Error while getting user deatils.";
  //           }
  //         })
  //         .then((res) => {
  //           return true;
  //         })
  //         .catch((err) => {
  //           logger("error", "Error from UserHeader onmount: " + url + ": buyerId =>  "+profileId+ ': error => ' +err, process.env.NEXT_PUBLIC_LOGGER_URL);
  //           console.log('error while getting user profile details UserHeader.js' ,err);
  //         });
  //       sessionStorage.setItem(
  //         "userLastActive",
  //         props.userProfile.userProfile.profileId
  //       );
  //     }
  //   }
  // }, [props.userProfile.userProfile]);

/** -- linesheet call to get pendingRFQsToView -- **/
  const getRFQStatus = (buyerCode) => {
    let status = 'SUBMITTED_TO_BUYER';
    let profileId = props.userProfile.userProfile.profileId || "";
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/home/linesheet/v1/pending-status/SUBMITTED_TO_BUYER/${buyerCode}?viewed=false`;
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((res) => {
        sessionStorage.setItem("isPendingRFQ", res.pendingRFQsToView);
        setIsPendingRFQ(res.pendingRFQsToView);
      })
      .catch((err) => {
        if (err.status === 401) {
          router.push("/signin");
        } else {
          if (retryCountRFQ < 3) {
            getRFQStatus();
          } else {
            console.log(
              "Error while fetching RFQ status details",
              err,
              "UserHeader"
            );
            logger(
              "error",
              "Error from UserHeader onmount: " +
                url +
                ": buyerId =>  " +
                profileId +
                ": error => " +
                err?.statusText,
              process.env.NEXT_PUBLIC_LOGGER_URL
            );
          }
          ++retryCountRFQ;
        }
      });
  }

  useEffect(() => {
    if(!sessionStorage.getItem('isPendingRFQ')){
      let buyerCode = props.userProfile.userProfile?.profileId.split("::")[1] || '';
      if(buyerCode){
        getRFQStatus(buyerCode);
      }
    }else{
      setIsPendingRFQ(JSON.parse(sessionStorage.getItem('isPendingRFQ')));
    }
  }, [props.userProfile.userProfile]);
/** -------- **/

  let {
    firstName = "",
    lastName = "",
    orgName = "",
    profileType = "",
    verificationStatus = "",
    profileId = "",
    email = "",
    country = "",
    orgPhone = "",
    username = "",
  } = userProfile || {};

  useEffect(() => {
    if(!props.userProfile.userProfile && localStorage.getItem('userProfile')){
      let profile = JSON.parse(localStorage.getItem('userProfile'));
      profileType = profile.profileType;
      setStateProfileType(profileType);
    }
  }, []);

  if(stateProfileType){
    profileType = stateProfileType;
  }

  let requesterName = firstName;
  if (lastName && lastName !== null) {
    requesterName = requesterName + " " + lastName;
  }

  let values = {
    profileId: profileId,
    profileType: profileType,
    category: "",
    requirementDetails: "",
    upload: {},
    quantity: "",
    pricePerItem: "",
    deliveryDate: "",
    requesterName: requesterName,
    companyName: orgName,
    emailId: email,
    country: country,
    city: "",
    mobileNo: orgPhone,
    preferedCurrency:
      typeof window !== "undefined"
        ? localStorage.getItem("CURRENCY_SELECTED") || "USD"
        : "USD",
    whatsappNumber : props && props.userProfile && props.userProfile.whatsappNumber,
    whatsappConsent : props && props.userProfile && props.userProfile.recieveWhatsappMessage,
  };

  let maskid = "";
  let prefix = email ? email.substring(0, email.lastIndexOf("@")) : "";
  let postfix = email ? email.substring(email.lastIndexOf("@")) : "";

  for (let i = 0; i < prefix.length; i++) {
    if (i == 0 || i == prefix.length - 1) {
      ////////
      maskid = maskid + prefix[i].toString();
    } else {
      maskid = maskid + "*";
    }
  }
  maskid = maskid + postfix;

  const showDrawer = () => {
    let state = !drawer;
    setDrawer(state);
  };

  const onClose = () => {
    setDrawer(false);
  };

  const sendQueryCancel = (status) => {
    if (status === "success") {
      setVisible(false);
      setSuccessQueryVisible(true);
    } else {
      setVisible(false);
    }
  };

  const successQueryCancel = () => {
    setSuccessQueryVisible(false);
    setInviteAccess(false);
  };

  const handleRedirect = () => {
    setSuccessQueryVisible(false);
    router.push("/");
  };

  const handleMyAccount = () => {
    router.push("/account/profile");
  };

  const handleVideoRequest = () => {
    router.push("/account/video");
  };
  // console.log(profileType)

  const handleQuotesRequest = () => {
    router.push("/account/quote");
  };

  const handleMyOrders = () => {
    router.push("/account/orders");
  };

  const handleAddress = () => {
    router.push("/account/addresses");
  };

  const handleMyCollections = () => {
    router.push("/account/collections");
  };
  const handleMyDropship = () => {
    router.push("/account/dropship");
  };

  const clearStorage = () => {
    sessionStorage.removeItem('isSocialSignup');
    localStorage.removeItem('kcTokenSaved');
    sessionStorage.removeItem('kcTokenSaved');
    localStorage.removeItem('longTimeUser');
    localStorage.removeItem('shortTimeUser');
    localStorage.removeItem('kcAccessToken');
    localStorage.removeItem('kcRefreshToken');
    localStorage.removeItem('rValidity');
    localStorage.removeItem('aValidity');
    router.push('/');
    window.location.reload();
  }

  const handleLogout = () => {
    // if (localStorage.getItem("webview") === "true") {
    //   sendDataToMobileApplication("Log Out", {
    //     logOut: "destroySession",
    //   });
    // }else{
    //   Moengage.destroy_session();
    // }
    cookie.remove("loggedInUser");
    logoutEvent();
    sessionStorage.removeItem('EDDData');
    sessionStorage.removeItem('isPendingRFQ');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('loggedInUser');
    // logoutFromApp(keycloak, undefined);
    if(localStorage.getItem('kcTokenSaved') || sessionStorage.getItem('kcTokenSaved')){
      let buyerId = props.userProfile?.userProfile?.profileId || null;
      let token = localStorage.getItem('kcAccessToken') || '';
      let rToken = localStorage.getItem('kcRefreshToken') || '';
      let data = {
        "clientId" : process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_CLIENT_ID,
        "refreshToken": rToken
      };

      let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL + '/identity/logout';
      if(token){
        props.keycloakLogout(token, buyerId, data, (res) => {
          console.log('response', res);
          if(res){
            console.log(res);
            sessionStorage.removeItem('isSocialSignup');
            clearStorage();
          } else {
            message('Something went wrong while logout. Please try again!', 5);
          }
        });
      } else {
        message('Empty token. Please try again!', 5);
      }
    } else {
      window.location.reload();
    }
  };

  const handleRecentlyViewed = () => {
    router.push("/recently-viewed/product");
  };

  const updateMember = async(params) => {
    let res;
    let profileId = props.userProfile ? props.userProfile?.userProfile?.profileId : "";
    try{
     const response = await fetch('/api/signup', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "email_address": params.email_address,
              "status": "subscribed",
              "merge_fields": params.merge_fields,
            }),
      });
     res = await response;
     // res = await response;
    } catch(error){
      console.log('error mailchimp', error);
      logger("error", "Error from mailchimp api: " +error+': buyerId => '+profileId, process.env.NEXT_PUBLIC_LOGGER_URL);
    }
  }

  const completeUserRegistration = (data) => {
    let token = localStorage.getItem('kcAccessToken') || null;
    let profile = JSON.parse(localStorage.getItem('userProfile'));
    let buyerId = props.userProfile?.userProfile?.profileId || profile?.profileId || null;
    if(token){
      props.completeUserRegistration(data, token, (result) => {
        let {error = ''} = result;
        if(error){
          message.error('Something went wrong. Please try again');
          window.location.reload();
        }else{
          // signupComplete(data);
          setVerificationModal(false);
          token && props.getUserProfile(token);
          // window.location.reload();
        }
      });
    } else {
      message.error('Something went wrong. Please try again');
    }
  }
  
  // useEffect(()=>{
  //   if(props?.userProfile?.userProfile){
  //         let indexValue;
  //         let profileId = null;
  //         if(props?.userProfile?.userProfile?.profileId){
  //           indexValue = props.userProfile.userProfile.profileId.indexOf(':');
  //           if(indexValue===-1){
  //             profileId = props.userProfile.userProfile.profileId;
  //           }else{
  //             profileId = props.userProfile.userProfile.profileId.slice(indexValue+2);
  //           }
  //         }
  //       if (localStorage.getItem("webview") === "true") {
  //         sendDataToMobileApplication("User_Attributes", {
  //           type: "UserAttributesData",
  //           user_attribute_data: {
  //             unique_userId: profileId,
  //             firstName: props?.userProfile?.userProfile?.firstName,
  //             lastName: props?.userProfile?.userProfile?.lastName,
  //             email: props?.userProfile?.userProfile?.email,
  //             orgPhone: props?.userProfile?.userProfile?.orgPhone,
  //             signupDate: moment(props?.userProfile?.userProfile?.createTimeStamp).format("YYYY-MM-DD"),
  //             country_attribute_value: props?.userProfile?.userProfile?.country,
  //             countryCode: props?.userProfile?.userProfile?.countryCode,
  //             buyer_id_attribute_value: profileId
  //           },
  //         });
  //       }else{
  //         if(Moengage){
  //           if(Moengage.add_first_name){
  //             Moengage.add_first_name(props?.userProfile?.userProfile?.firstName);
  //          }
  //          if(Moengage.add_last_name){
  //             Moengage.add_last_name(props?.userProfile?.userProfile?.lastName);
  //           }
  //          if(Moengage.add_email){
  //             Moengage.add_email(props?.userProfile?.userProfile?.email);
  //           }
  //           if(Moengage.add_mobile){
  //             Moengage.add_mobile(props?.userProfile?.userProfile?.orgPhone);
  //          }
  //          if(Moengage.add_unique_user_id){
  //            Moengage.add_unique_user_id(profileId);
  //           }
  //          if(Moengage.add_user_attribute){
  //             Moengage.add_user_attribute("Country", props?.userProfile?.userProfile?.country);
  //             Moengage.add_user_attribute("Signup_Date", moment(props?.userProfile?.userProfile?.createTimeStamp).format("YYYY-MM-DD"));
  //             Moengage.add_user_attribute("countryCode", props?.userProfile?.userProfile?.countryCode);
  //             Moengage.add_user_attribute("Buyer_Id", profileId);
  //          }
  //       }
  //     }
  //   }
  // },[props.userProfile.userProfile])
  
  useEffect(()=>{
    if(props?.userProfile?.userProfile){
      cookie.set("loggedInUser", true);
    }
  },[props.userProfile.userProfile]);

  useEffect(()=>{
    if(pathname){
      const indexValue = pathname.slice(1).indexOf('/');
      const currentPage= pathname.slice(1,indexValue+1);
      if(currentPage!="search"){
        sessionStorage.setItem("searchTerm",null);
        if(sessionStorage.getItem("previousSearchTerm")){
          sessionStorage.removeItem("previousSearchTerm");
        }
      }
    }
	  },[pathname])
    
    useEffect(()=>{
      if(window){
        window.addEventListener("beforeunload", function(e){
          let searchTerm=sessionStorage.getItem("searchTerm");
          if(searchTerm!="null"){
            let exitData = JSON.parse(localStorage.getItem("searchExitData"))
            if(exitData){
              let isTermExist = exitData?.exitData?.find((item)=>item.searchTerm==searchTerm);
              if(!isTermExist){
                localStorage.setItem("searchExitData",JSON.stringify({
                  exitData: [...exitData.exitData,{isSearchExit: "yes",searchTerm}]
                }));
                search_exit(searchTerm);
              }
            }else{
              localStorage.setItem("searchExitData",JSON.stringify({
                exitData:[{isSearchExit: "yes",searchTerm}]
              }));
              search_exit(searchTerm);
            }
          }
        })
      }
    },[])
  
  return (
    <>
    {/* given some space to banner because there are some in in the mobile ios app header */}
    {isMobile && <div className="mobile-header-banner-space"/>}
    <Row style={{ zIndex: isMobile ? 9 : 2, width: "100%", position: isMobile ? "fixed" : "sticky", top: "0" }}>
      {!isMobile && isDeviceDetected ? 
        <Col xs={0} sm={0} md={0} lg={24} xl={24}>
          {/* <AnnouncementTicker/> */}
          <Header className="app-header">
            <Col
              xs={0}
              sm={0}
              md={6}
              lg={6}
              xl={6}
              // style={{ textAlign: "left", margin: "auto", position: "initial" }}
            >
              <div className="logo-div" onClick={() => topNavigation("home icon")}>
                <Link href="/">
                  <div className="link-to-home" style={{
                    display: "flex",
                    flexDirection: "column", // Stack icon & text vertically
                    alignItems: "center", // Center align horizontally
                    textAlign: "center", 
                  }}>
                    <Icon
                      component={homeIconHeader}
                      className="cart-icon"
                      style={{
                        width: "32px",
                        verticalAlign: "middle",
                        marginLeft: "5px",
                        textAlign:'center',
                        cursor: "pointer",
                      }}
                    />
                    <br />
                    <span className="home-text qa-font-san" style={{ fontSize: "14px" }}>Home</span>
                  </div>
                </Link>
                <div className="logo" style={{marginLeft: "20px"}}>
                <Link
                  href="/"
                  style={{
                    textDecoration: "none",
                  }}
                >
                   <ReactSVG src="/qalara_logo_web.svg" />
                  {/*<img  onClick={() => topNavigation("logo clicked")} src="/filestore/logo2.png" className="logo-png" />*/}
                </Link>
              </div>
              </div>
            
            </Col>
            <Col 
               xs={0}
               sm={0}
               md={8}
               lg={8}
               xl={8}
               style={{ textAlign: "center", margin: "auto", }}
            >
              <div className="searchMenu-section">
               {/*<div> {searchMenu}</div>*/}
               <HeaderSearchWeb />
              </div>
            </Col>
            
            <Col
              xs={0}
              sm={0}
              md={10}
              lg={10}
              xl={10}
              style={{
                textAlign: "right",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {userStatus ?
                isAuthenticated ? (
                    <div className="signin" key="SIGNED-IN">
                      
                      {(profileType !== "SELLER") && (<Link
                          className="currency-converter"
                          href="/account/quote"
                          style={{
                            textDecoration: "none",
                          }}
                        >
                          <div className="link-to-quote nav-item-group" >
                         
                           
                          <div style={{position:'relative'}}>
                           <RfqNewIcon></RfqNewIcon>
                            {isPendingRFQ && ( <img  src='/filestore/quotation/quoteNotification.png' className="quote-icon quote-notification-position" />)}    
                          </div>
                            <br />
                            <span className="quote-text header-text-style">Quotations</span>
                          </div>
                        </Link>
                      )}
                        

                      {( profileType !== "SELLER") && (<Link
                          className="currency-converter"
                          href="/cart"
                          style={{
                            textDecoration: "none",
                          }}
                        >
                          <div className="link-to-cart nav-item-group"
                            onClick={() => topNavigation("cart icon clicked")}
                          >
                            <div style={{position:'relative'}}>
                         <NewCartIcon></NewCartIcon>
                         {props.cartProductsQuantity > 0 && <span className="cartNotification-shadow cart-notification-position">{props.cartProductsQuantity}{console.log("testing::cart count in header--",props.cartProductsQuantity)}</span>}
                          </div>
                            <br />
                            <span className="cart-text header-text-style">Cart</span>
                          </div>
                        </Link>
                      )}

                      {profileType !== "SELLER" && (
                        <Link
                          className="currency-converter"
                          href="/account/collections/"
                          style={{
                            textDecoration: "none",
                          }}
                        >
                          <div className="link-to-collections nav-item-group">
                            <HeaderCollectionIcon onClick={() => topNavigation("collection icon clicked")}></HeaderCollectionIcon>
                            <br />
                            <span className="collections-text header-text-style">
                              Collections
                            </span>
                          </div>
                        </Link>
                      )}
                        {
                          <UserMenu 
                            handleUserMenu={handleUserMenu}
                            accVisible={accVisible}
                            isGuest={props.isGuest}
                            handleMyAccount={handleMyAccount}
                            userProfile={userProfile}
                            topNavigation={topNavigation}
                            handleMyOrders={handleMyOrders}
                            profileType={profileType}
                            handleQuotesRequest={handleQuotesRequest}
                            handleMyCollections={handleMyCollections}
                            handleMyDropship={handleMyDropship}
                            handleAddress={handleAddress}
                            handleRecentlyViewed={handleRecentlyViewed}
                            poorProfileStatus={poorProfileStatus}
                            verificationStatus={verificationStatus}
                            handleLogout={handleLogout}
                            orgName={orgName}
                            firstName={firstName}
                          />
                        } 

                        {!['/payment','/shipping', '/RTS/order-review/[orderId]'].includes(router.pathname) && <CurrencyConverter />}
                    </div>
                  ) : (
                    <div className="anonymous" key="ANONYMOUS">

                      <span
                        className="currency-converter"
                        // href="/request-for-quote"
                        style={{
                          textDecoration: "none",
                        }}
                      >
                        <>
                        <div className="link-to-quote" onClick={()=>{
                          setModalVisible(true);
                          rfq_click("Qalara RFQ","Guest");
                          }}>
                       
                         
                        <div style={{position:'relative'}}>
                        <RfqNewIcon></RfqNewIcon>
                        </div>
                        
                        
                          <br />
                          <span className="quote-text header-text-style">Request quote</span>
                        </div>
                        {/*<Suspense fallback={''}>*/}
                          {modalVisible && <HomeModal visible={modalVisible} setVisible={setModalVisible}/>}
                        {/*</Suspense>*/}
                        </>
                      </span>

                     <Link
                        className="currency-converter link-to-cart"
                        href="/cart"
                        style={{
                          textDecoration: "none",
                        }}
                        onClick={() => topNavigation("cart icon clicked")}
                      >
                        {/*<a
                          className="link-to-cart"
                          onClick={() => topNavigation("cart icon clicked")}
                        >*/}
                          {/* <ShoppingCartOutlined className="cart-icon" /> */}
                          <NewCartIcon></NewCartIcon>
                          <br />
                          <span className="cart-text header-text-style">Cart</span>
                        {/*</a>*/}
                      </Link>

                      <span
                        onClick={() => {
                          topNavigation("sign in");
                          handleLogin();
                        }}
                        className="qa-cursor user-login"
                      >
                        <span style={{marginLeft:"6px"}}>
                          <Icon
                            component={accountIcon}
                            className="account-icon qa-cursor"
                          />
                        </span>
                        <br />
                        <span className="my-account-header qa-cursor header-text-style account-text">
                          Sign in
                        </span>
                      </span>
                      {/* </Popover> */}
                      <Button
                        className="send-query-button"
                        onClick={() => {
                          topNavigation("SIGN UP AS A BUYER");
                          handleSignUp();
                        }}
                      >
                        <div className="send-query-button-text qa-rfq-button">
                          SIGN UP AS A BUYER
                        </div>
                      </Button>
                     <span style={{color:'black'}}> {!['/payment','/shipping'].includes(router.pathname) && <CurrencyConverter />}</span>
                    </div>
                  )
                  : null

              }
            </Col>
          </Header>
          {/*removed web nav bar from here */}
          <NavBar />
        </Col>
        : null
      }
      {isMobile && isDeviceDetected
        ? 
        <Col xs={24} sm={24} md={24} lg={0} xl={0}>
          {/* <AnnouncementTicker/> */}
          <Header className="app-header">
            {isMobile && typeof window != "undefined" &&
              window.location.pathname !== sessionStorage.getItem("parentUrl") &&
              window.history.length > 2 ? (
                <Icon
                  onClick={() => history.go(-1)}
                  component={backIcon}
                  className=" back-btn"
                 
                />
              ) : localStorage.getItem("webview") == "true" ? (
                <Icon
                  onClick={() => history.go(-1)}
                  component={backIcon}
                  className=" back-btn"
                 
                />) : 
              null
            }
            <div className="logo-with-text">
              <Link href="/" style={{ textDecoration: "none" }}>
                <ReactSVG src="/qalara_logo_web.svg" />
                {/*<img src="/filestore/logo2.png" className="logo-png" />*/}
              </Link>
            </div>

            <div
              className="app-header-mobile"
            >
              <div id="mob-header" className="mob-header-right">
                {
                  isAuthenticated &&  profileType !== 'SELLER' &&
                  <>
                    <div>
                      <Link
                         href="/account/quote"
                         style={{
                           textDecoration: "none",
                         }}
                       >
                        <div>
                          <div className="quote-icon-text">
                            <div style={{position:'relative', }}>
                               <MobRfqIcon></MobRfqIcon>
                              {isPendingRFQ && ( <img  src='/filestore/quotation/quoteNotification.png' className="quote-icon" style={{position:'absolute', top:-4, left:"50%", height:15, width:15}}/>)}
                            </div>
                          </div>
                          <div className="quote-text">Quotations</div>
                        </div>
                      </Link>
                    </div>
                    <div>
                      <Link
                         href="/cart"
                         style={{
                           textDecoration: "none",
                         }}
                         onClick={() => topNavigation("cart icon clicked")}
                       >
                        <span className="mob-cart-icon">
                        <MobCartIcon></MobCartIcon>
                        {props.cartProductsQuantity > 0 && <span className="cartNotification-shadow cart-notification-position">{props.cartProductsQuantity}</span>}
                           </span>
                         <div className="cart-text">Cart</div>
                      </Link>
                    </div>
                    {!!userProfile?.productsInCart && <span className="cart-notification"></span>}
                  </>
                } 
                {
                    (!isAuthenticated) &&  <div
                    className="quote-icon-text mob-signup"
                   onClick={() => {
                     topNavigation("my account click");
                     handleSignUp();
                   }}
                   // type="link"
                 >
                   <MyAccountIconW
                   />
                    {/* <img src="/fileStore/accountIcon.png"  fillColor= "#191919" style={{width:'15px'}}/> */}
                  
                    <span className="signup-text">Sign Up</span>
                  
                 </div>
                }
                <div
                  className=""
                  onClick={() => {
                    topNavigation("hamburger click");
                    showDrawer();
                  }}
                >
                  <MenuOutlined className="menu-icon" />
                </div>
              </div>
              {
                drawer ? 
                  <DrawerMobile 
                    drawer={drawer} 
                    onClose={onClose} 
                    isAuthenticated={isAuthenticated} 
                    userProfile={userProfile} 
                    handleMyAccount={handleMyAccount}
                    handleMyOrders={handleMyOrders}
                    handleQuotesRequest={handleQuotesRequest}
                    handleMyCollections={handleMyCollections}
                    handleAddress={handleAddress}
                    handleRecentlyViewed={handleRecentlyViewed}
                    handleLogout={handleLogout}
                    handleLogin={handleLogin}
                    handleSignUp={handleSignUp}
                    convertToCurrency={convertToCurrency}
                  />
                : null
              }
            </div>
          </Header>
          <div id='mob-search'>
            {/*{searchMenuMob}*/}
            <HeaderSearchMob />
          </div>
        </Col>
        : null
      }
      <Modal
        visible={successQueryVisible}
        footer={null}
        closable={true}
        onCancel={successQueryCancel}
        centered
        bodyStyle={{ padding: "0" }}
        width={400}
        className="rfq-submission-modal"
      >
        <div id="send-query-success-modal">
          <div className="send-query-success-modal-content">
            <p className="send-query-success-modal-para1">Thank you!</p>
            <p className="send-query-success-modal-para2">
              We have received your Sourcing request, and will revert within the
              next 48-72 hours.
            </p>
          </div>
          <Button
            className="send-query-success-modal-button"
            onClick={handleRedirect}
          >
            Back to home page
          </Button>
        </div>
      </Modal>
      <Modal
        visible={inviteAccess}
        footer={null}
        closable={false}
        onCancel={successQueryCancel}
        centered
        bodyStyle={{ padding: "0" }}
        width={600}
        className="invite-access-modal"
      >
        <div id="send-query-success-modal">
          <div
            onClick={successQueryCancel}
            style={{
              position: "absolute",
              right: "15px",
              top: "15px",
              cursor: "pointer",
              zIndex: "1",
            }}
          >
            <Icon
              component={closeButton}
              style={{ width: "30px", height: "30px" }}
            />
          </div>
          <div className="send-query-success-modal-content">
            <p className="send-query-success-modal-para1">Invite only access</p>
            <p className="send-query-success-modal-para2">
              Welcome to the invite-only preview of Qalara. You are amongst a
              select group invited to experience Qalara and share your valuable
              feedback.
            </p>
            <p className="send-query-success-modal-para2">
              We have sellers across Home & Lifestyle categories. Our seller
              portfolio increases daily, so keep coming back to check in!{" "}
              <b>
                Invitees have access to our Seller's product catalogs and the
                new video demo feature.
              </b>
            </p>
            <p
              className="send-query-success-modal-para2"
              style={{ marginBottom: "0px", fontSize: "12px" }}
            >
              Please click the button below and enter your Invite-only Username
              and Code for unrestricted access to Qalara.
            </p>
          </div>
          <Button
            className="send-query-success-modal-button"
            onClick={() => {}}
          >
            SIGN IN TO UNLOCK ACCESS
          </Button>
          <p className="send-query-success-modal-para2">
            <b>
              Note: If you are a buyer, you may email us at{" "}
              <a href="mailto:buyers@qalara.com">buyers@qalara.com</a> with
              details of your company to get an Invite Code.
            </b>
          </p>
        </div>
      </Modal>

      <Modal
        className="confirmation-modal"
        visible={confirmationModal}
        footer={null}
        closable={false}
        bodyStyle={{
          background: "#332F2F",
          boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
          color: "#F9F7F2",
        }}
        width={750}
        centered
      >
        <div className="qa-rel-pos qa-pad-1">
          <div
            onClick={closeConfimationModal}
            style={{
              position: "absolute",
              right: "0px",
              top: "0px",
              cursor: "pointer",
              zIndex: "1",
            }}
          >
            <Icon
              component={closeButton}
              style={{ width: "30px", height: "30px" }}
            />
          </div>
          <div>
            {uProfile === "BUYER" ? (
              <p className="verification-heading home-page">
                Please set your password to complete the sign-up process
              </p>
            ) : (
              <p className="verification-heading home-page">Sign up complete</p>
            )}
            {uProfile === "BUYER" ? (
              <p className="verification-text">
                Please go to your email account and look for an email from{" "}
                <b>'Qalara Global'</b> (check in the{" "}
                <b>
                  <i>spam folder</i>
                </b>{" "}
                if you dont find it in your inbox). Click on the link in that
                email to set your password, and then proceed to sign in with
                your new password to start browsing our wide range of products.
                <br />
                <br /> If you face any issues, please write to us at{" "}
                <span className="qa-underline qa-primary-c">
                  {uProfile === "BUYER"
                    ? "buyers@qalara.com"
                    : "help@qalara.com"}
                </span>
              </p>
            ) : (
              <p className="verification-text">
                Thanks for showing interest in joining our platform. Please set
                the password for your account using the link sent to your
                registered email address. To continue your registration process,
                select the 'Apply to be a seller' option from your profile page
              </p>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        className="confirmation-modal user-registration-modal"
        visible={verificationModal}
        // onCancel={{}}
        // visible={true}
        footer={null}
        closable={false}
        bodyStyle={{ padding: "20px", backgroundColor: "#f9f7f2" }}
        width={mediaMatch.matches ? 750 : "100%"}
        centered
        getPopupContainer={(trigger) => trigger.parentElement}
      >
        <CompleteProfileForm
          user={userProfile}
          profileType={profileType}
          completeUserRegistration={(data) => {completeUserRegistration(data)}}
          userProfile={props.userProfile.userProfile}
        />
      </Modal>
     
      <Modal
        visible={otpVerificationModal}
        className="otp-verification-modal"
        footer={null}
        closable={false}
        onCancel={hideOtpModal}
        centered
        bodyStyle={{ padding: "30px", backgroundColor: "#f9f7f2" }}
        width={mediaMatch.matches ? 750 : "100%"}
        getPopupContainer={(trigger) => trigger.parentElement}
      >
        <div className="qa-rel-pos">
          <div
            onClick={hideOtpModal}
            style={{
              position: "absolute",
              right: "0px",
              top: "0px",
              cursor: "pointer",
              zIndex: "1",
            }}
          >
            <Icon
              component={closeButton}
              style={{ width: "30px", height: "30px" }}
            />
          </div>
          <div>
            {!otpValidated ? (
              <div>
                <div className="otp-email-title">
                  {profileType === "BUYER"
                    ? "Welcome to Qalara! Please validate your email address to enable online checkout."
                    : "Welcome to Qalara! Please validate your email address."}
                </div>
                <div className="otp-subtitle">
                  {profileType === "BUYER" && verificationStatus === "VERIFIED"
                    ? "You can now browse all products, view prices, create collections, add to cart and more! But please validate your email address to enable online checkout."
                    : profileType === "BUYER" &&
                      verificationStatus !== "VERIFIED"
                    ? "Your Buyer Account will be verified within 48 hours and we may reach out to you for additional information. We do this to ensure a trusted platform for buyers and sellers."
                    : "We do this to ensure a trusted platform for buyers and sellers."}
                </div>
                <div className="otp-email-detail">
                  Enter the One Time Password (OTP) sent to your registered
                  email address {maskid}
                </div>
                <div className="otp-input-field">
                  <OtpInput
                    value={otpInput}
                    onChange={handleOtpChange}
                    numInputs={6}
                    separator={<span></span>}
                    focusStyle="focussed-input"
                    shouldAutoFocus={true}
                  />
                </div>
                {otpLengthError && (
                  <div className="email-verification-text">
                    Please enter 6 digits OTP
                  </div>
                )}
                {otpError && (
                  <div className="email-verification-text">
                    The OTP entered is incorrect. Please enter the correct OTP
                  </div>
                )}
                <div className="otp-btn-section qa-mar-top-2">
                  <Button
                    onClick={validateOtp}
                    disabled={btnLoading}
                    loading={btnLoading}
                    className="qa-button qa-send-otp"
                  >
                    VALIDATE OTP
                  </Button>
                </div>
                <div
                  className="resend-otp-btn"
                  onClick={() => {
                    setOtpInput("");
                    sendOtp();
                  }}
                >
                  RESEND OTP
                </div>
                <div className="otp-help-section">
                  Please check your promotions/spam/junk folder if you have not
                  received the OTP in your primary inbox. If you haven't
                  received the OTP or are facing any issues please write to us
                  at{" "}
                  <a
                    href="mailto:help@qalara.com"
                    className="qa-sm-color qa-underline"
                  >
                    help@qalara.com
                  </a>{" "}
                  from your registered email address.
                </div>
                <div className="skip-continue-browsing" onClick={hideOtpModal}>
                  SKIP & CONTINUE BROWSING
                </div>
              </div>
            ) : (
              <div>
                <div className="otp-email-title">
                  Your email validation is successful!{" "}
                </div>
                <div style={{ textAlign: "center" }}>
                  <CheckCircleOutlined
                    style={{
                      fontSize: "60px",
                      marginTop: "10px",
                      marginBottom: "20px",
                      color: "#d9bb7f",
                    }}
                  />
                  {verificationStatus === "VERIFIED" ? (
                    <div className="qa-mar-btm-3 otp-validated">
                      Thank you for validating your email address. Online
                      checkout is now enabled for your Qalara account.
                    </div>
                  ) : (
                    <div
                      className="qa-mar-btm-3 otp-validated"
                      style={{ textAlign: "center" }}
                    >
                      Thank you for validating your email address.{" "}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>

      {shopColor && (
        <div
          style={{ top: isShowRibbon ? "110px" : "70px" }}
          id="overlay"
        ></div>
      )}
    </Row>
    </>
  );
  
}

const mapStateToProps = (state) => {
  return {
    priceDetails: state.currencyConverter,
    userProfile: state.userProfile,
    auth: state.auth,
    meetingCount: state.userProfile.meetingCount,
    cartProductsQuantity: 
    state.cartProductsQuantity &&
    state.cartProductsQuantity.cartProductsQuantity,
    isGuest:
      state.auth &&
      state.auth.userAuth &&
      state.auth.userAuth.attributes &&
      state.auth.userAuth.attributes.isGuest &&
      state.auth.userAuth.attributes.isGuest[0],
    receivePromoEmails: 
      state.auth &&
      state.auth.userAuth &&
      state.auth.userAuth.attributes &&
      state.auth.userAuth.attributes.receivePromoEmails &&
      state.auth.userAuth.attributes.receivePromoEmails[0],
    profileType:
      state.userProfile &&
      state.userProfile.userProfile &&
      state.userProfile.userProfile.profileType,
  };
};

export default connect(mapStateToProps, {
  getUserProfile,
  getCurrencyConversion,
  getCurrentFormat,
  completeUserRegistration,
  getTokenFromRefreshToken,
  getAccessTokenSocial,
  saveUserIPDetails,
  keycloakLogout,
  getCartProductQuantity
})(UserHeader);